import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Button } from "react-bootstrap";
import { useProvider } from '../../context/MenuProvider';

export default function GaleriaApresentacao() {
  const [todosAtalhos, setTodosAtalhos] = useState([]);
  const [atalhoTopo, setAtalhoTopo] = useState([]);
  const [atalhoMeio, setAtalhoMeio] = useState([]);
  const [atalhoRodape, setAtalhoRodape] = useState([]);
  const [blocoAtivo, setBlocoAtivo] = useState(0);

  const { crud, setTitle, hasPerms } = useProvider();
  const { get, post } = crud || {};

  useEffect(() => {
    setTitle("Acesso Rápido");
  }, []);

  useEffect(() => {
    const carregar = async () => {
      try {
        const response = await get([
          "/core/links/?ordering=nome_curto&ativo=true&limit=500",
          "/core/atalhos/"
        ]);

        if (response && response.length) {
          const links = (response[0].results || [])
            .filter((x) => hasPerms(x.perms) || !x.perms?.length);

          setTodosAtalhos(links);

          const data = response[1].results?.[0] || {};

          setAtalhoTopo(mapIdsParaObjetos(data.home_topo, links));
          setAtalhoMeio(mapIdsParaObjetos(data.home_meio, links));
          setAtalhoRodape(mapIdsParaObjetos(data.fother, links));
        }
      } catch (e) {
        console.log("Erro ao carregar atalhos:", e);
      }
    };
    carregar();
  }, []);

  // Corrigido: nunca gera undefined
  const mapIdsParaObjetos = (listaIds, links = []) =>
    (listaIds || [])
      .map((id) => links.find((a) => Number(a.id) === Number(id)))
      .filter(Boolean);

  const addAtalho = (dest, item) => {
    const map = {
      topo: [atalhoTopo, setAtalhoTopo],
      meio: [atalhoMeio, setAtalhoMeio],
      rodape: [atalhoRodape, setAtalhoRodape],
    };
    const [lista, setLista] = map[dest];

    const existe = lista.find((i) => i?.id === item.id);
    if (existe) {
      setLista(lista.filter((i) => i?.id !== item.id));
    } else {
      setLista([...lista.filter(Boolean), item]);
    }
  };

  const reordenar = (result, state, setState) => {
    if (!result.destination) return;

    const novaOrdem = Array.from(state.filter(Boolean));
    const [removido] = novaOrdem.splice(result.source.index, 1);
    novaOrdem.splice(result.destination.index, 0, removido);
    setState(novaOrdem);
  };

  const salvar = async () => {
    try {
      const dados = {
        home_topo: atalhoTopo.filter(Boolean).map(i => Number(i.id)),
        home_meio: atalhoMeio.filter(Boolean).map(i => Number(i.id)),
        fother: atalhoRodape.filter(Boolean).map(i => Number(i.id)),
      };

      const response = await post(dados, "/core/atalhos/");
      if (response && response.length) {
        navigator.serviceWorker.controller?.postMessage('baixar-atalhos');
      }
    } catch (e) {
      console.log(e);
      alert("Erro ao salvar");
    }
  };

  const blocos = [
    { nome: "Topo da página inicial", itens: atalhoTopo, setItens: setAtalhoTopo, droppableId: "topo" },
    { nome: "Meio da página inicial", itens: atalhoMeio, setItens: setAtalhoMeio, droppableId: "meio" },
    { nome: "Menu Rodapé", itens: atalhoRodape, setItens: setAtalhoRodape, droppableId: "rodape", subnome: "Em celulares só aparecem os 4 primeiros" },
  ];

  const Lista = ({ nome, subnome, itens, setItens, droppableId }) => (
    <div className="mb-4">
      <div className="fs-4">{nome}</div>
      {subnome && <div className="text-muted small">{subnome}</div>}

      <Droppable droppableId={droppableId} type={droppableId} isCombineEnabled={false}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{ background: "#eee", padding: 10, minHeight: 120 }}
          >
            {itens.filter(Boolean).map((item, index) => (
              <Draggable key={String(item.id)} draggableId={String(item.id)} index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.dragHandleProps}
                    {...provided.draggableProps}
                    style={{
                      ...provided.draggableProps.style,
                      background: "#fff",
                      padding: 10,
                      marginBottom: 8,
                      borderRadius: 8,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 10
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <i className={item.icone || ""} style={{ fontSize: 22 }}></i>
                      <div>
                        <div>{item.nome || "Sem nome"}</div>
                        <div className="text-muted small">{item.descricao || ""}</div>
                      </div>
                    </div>
                  
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => setItens(prev => prev.filter(x => x.id !== item.id))}
                    >
                      <i className="bx bx-trash"></i>
                    </Button>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      <div className="mt-2">
        {todosAtalhos.filter(Boolean).map((t) => {
          const existe = itens.some((i) => i?.id === t.id);
          return (
            <Button
              key={t.id}
              size="sm"
              variant={existe ? "danger" : "primary"}
              className="me-1 mb-1"
              onClick={() => addAtalho(droppableId, t)}
            >
              <i className={t.icone || ""}></i> {t.nome || "Sem nome"}
            </Button>
          );
        })}
      </div>
    </div>
  );

  return (
    <div>
      <p>Clique para adicionar/remover e arraste para reorganizar. Depois clique em <strong>Salvar</strong>.</p>

      <Button onClick={salvar} className="mb-3" variant="success">
        Salvar alterações
      </Button>

      <div className="d-flex justify-content-between mb-3">
        <Button
          onClick={() => setBlocoAtivo((prev) => (prev > 0 ? prev - 1 : 0))}
          disabled={blocoAtivo === 0}
        >
          ⬅️
        </Button>

        <div>{blocos[blocoAtivo].nome}</div>

        <Button
          onClick={() => setBlocoAtivo((prev) => (prev < blocos.length - 1 ? prev + 1 : blocos.length - 1))}
          disabled={blocoAtivo === blocos.length - 1}
        >
          ➡️
        </Button>
      </div>

      <DragDropContext
        onDragEnd={(r) => {
          const bloco = blocos[blocoAtivo];
          reordenar(r, bloco.itens, bloco.setItens);
        }}
      >
        <Lista {...blocos[blocoAtivo]} />
      </DragDropContext>
    </div>
  );
}